module.exports = __webpack_public_path__ + "static/media/0055_Medium.344965c9.jpg";